import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoadingSpinner from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { getLeaveApplication } from "../services/LeaveApplicationService";
import type { LeaveApplication } from "../types/leave-application.types";
import LeaveApplicationOverviewContext from "./LeaveApplicationOverviewContext";
import Section from "./Section";

const LeaveApplicationOverview = () => {
  document.title = getDocumentTitle("Leave application");
  const { id } = useParams();
  const [record, setRecord] = useState<LeaveApplication | null>(null);
  const [loading, setLoading] = useState(true);
  const [summaryKey, setSummaryKey] = useState(0);

  const refetch = useCallback(async () => {
    if (!id) return;
    try {
      const res = await getLeaveApplication(Number(id));
      if (res.success && res.data) {
        setRecord(res.data);
        setSummaryKey((k) => k + 1);
      } else {
        setRecord(null);
      }
    } catch (err) {
      console.warn(err);
      setRecord(null);
    }
  }, [id]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      setLoading(true);
      await refetch();
      if (!cancelled) setLoading(false);
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [id, refetch]);

  if (loading) {
    return <PageLoadingSpinner message="Loading leave application…" />;
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Leave application"
          pageTitle="HR Management"
          items={[
            {
              label: "Leave applications",
              path: "/hr-management/leave-applications",
            },
          ]}
        />
        <LeaveApplicationOverviewContext.Provider value={{ record, refetch, summaryKey }}>
          <Section />
        </LeaveApplicationOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default LeaveApplicationOverview;
